import styled from 'styled-components'

export const HeaderInfo = styled.div`
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
box-sizing: border-box;
padding-left: 5px;
padding-right: 5px;

 div {
  display: flex;
  gap: 3px;

  label{
    font-size: 13px;
    font-weight: bold;
  }

  p {
    font-size: 13px;
  }
 }
`